export default function initEditionPicker() {

    const $editionPicker = $(".edition-picker"),
        trigger = "[data-edition-picker]",
        openingEditionPickerClass = "edition-picker--opening",
        openEditionPickerClass = "edition-picker--open";

    const closeEditionPicker = function () {
        $editionPicker.removeClass(openEditionPickerClass);
        window.setTimeout(function () {
            $editionPicker.removeClass(openingEditionPickerClass);
        }, 50);
    };

    const openEditionPicker = function () {
        $editionPicker.addClass(openingEditionPickerClass);
        window.setTimeout(function () {
            $editionPicker.addClass(openEditionPickerClass);
        }, 50);
    };

    $(trigger).click(function () {

        if($editionPicker.hasClass(openingEditionPickerClass)) {
            closeEditionPicker();
        } else {
            openEditionPicker();
        }

        return false;
    });

    $(document).keyup(function (e) {
        if(e.keyCode === 27 && $editionPicker.hasClass(openingEditionPickerClass)) {
            closeEditionPicker();
        }
    });

}



// WEBPACK FOOTER //
// ./js/navbar/commons/NavbarEditionPicker.js